import { derived, writable } from "svelte/store";
import * as local from "./local.js";
import { encodingToHex, createRandomVisibleEncoding } from "bitframes";

export const MAX_AMOUNT = 1000;
const LOCAL_KEY = "history";

const initialState = local.get(LOCAL_KEY, []);

const initial = [];
for (let item of initialState) {
  if (typeof item === "string") {
    initial.push([item, false]);
  } else if (Array.isArray(item)) {
    initial.push(item.slice());
  } else {
    // skip ?
  }
}

// while (initial.length < MAX_AMOUNT) {
//   initial.push([encodingToHex(createRandomVisibleEncoding()), false]);
// }

export const store = writable(initial);
export const encodingStore = derived(store, (list) => list.map((n) => n[0]));

store.subscribe((data) => {
  local.set(LOCAL_KEY, data);
});

export function markFavorite(encodingHex) {
  store.update((list) => {
    return list.map((item) => {
      if (item[0] === encodingHex) {
        return [item[0], true];
      } else {
        return item;
      }
    });
  });
}

export function unmarkFavorite(encodingHex) {
  store.update((list) => {
    return list.map((item) => {
      if (item[0] === encodingHex) {
        return [item[0], true];
      } else {
        return item;
      }
    });
  });
}

export function toggleFavorite(encodingHex) {
  store.update((list) => {
    return list.map((item) => {
      if (item[0] === encodingHex) {
        return [item[0], !item[1]];
      } else {
        return item;
      }
    });
  });
}

export function getMaxCount() {
  return MAX_AMOUNT;
}

export function clear() {
  store.update(() => []);
}

export function update(fn) {
  return store.update(fn);
}

export function remove(encodingHex) {
  return store.update((list) => {
    return list.filter((item) => {
      if (item[0] === encodingHex) {
        return false;
      }
      return true;
    });
  });
}

function find(list, encodingHex) {
  return list.find((e) => {
    const enc = e[0];
    return enc === encodingHex;
  });
}

export function push(encoding) {
  return store.update((list) => {
    if (find(list, encoding)) return list;
    list = list.slice();
    if (list.length >= MAX_AMOUNT) {
      list.shift();
      // list.pop();
    }
    list.push([encoding, false]);
    return list;
  });
}
